function formatError(error) {
  if (!error) {
    return '';
  }

  if (error.messages && error.messages.length) {
    return `error[${error.messages.join(', ')}]`;
  }

  if (error.error && error.error.messages && error.error.messages.length) {
    return `error[${error.error.messages.join(', ')}]`;
  }

  return `error[${error.toString()}]`;
}

function formatStatus(response) {
  if (!response || !response.status) {
    return '';
  }

  return `status[${response.status}]`;
}

function formatObject(obj) {
  if (!obj) {
    return '';
  }

  return `response[${JSON.stringify(obj)}]`;
}

function formatApiResponse(response) {
  if (response instanceof Error) {
    return response.stack;
  }

  if (!response) {
    return 'Unknown Error';
  }

  const parts = [];

  if (response.error) {
    parts.push(formatError(response.error));
  }

  if (response.messages) {
    parts.push(formatError({ error: { messages: response.messages } }));
  }

  if (response.status) {
    parts.push(formatStatus(response.status));
  }

  if ((!response.error && !response.messages && !response.status) &&
    typeof response === 'object') {
    parts.push(formatObject(response));
  }

  return parts.join(' ');
}

module.exports = formatApiResponse;



// WEBPACK FOOTER //
// ./static/js/v0/utilities/format-api-response.js